// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2e-1";
export var movingGradient = "_2e-4";
export var movingGradientBlock = "_2e-2";
export var skeleton = "_2e-0";
export var skeletonText = "_2e-3";